export const sdkWrapperURL = (url = "") =>
  new URL(url, "https://retail-api-stage-sdk-wrapper-app.carenow.healthcare");
export const sdkURL = (url = "") => new URL(url, "https://sdk-staging.carenow.healthcare");
